import { render, staticRenderFns } from "./FAQs-detail.vue?vue&type=template&id=67622150&"
import script from "./FAQs-detail.js?vue&type=script&lang=js&"
export * from "./FAQs-detail.js?vue&type=script&lang=js&"
import style0 from "./FAQs-detail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports